import { createApiQuery } from '@/hooks/use-api-query';
import { HomeRes, HomeReq } from '@/types/api/hall/casino/home.d';
import { get } from '@/libs/http';

// 类型：1 banner，2 游戏容器，3 游戏集-自定义，4 游戏集-厂商	
export enum ModuleType {
  BANNER = 1,
  GAME_CONTAINER = 2,
  GAME_SET_CUSTOM = 3,
  GAME_SET_PROVIDER = 4,
}

// 状态：1 正常，2 维护，3 关闭
export enum GameStatus {
  NORMAL = 1,
  MAINTENANCE = 2,
  CLOSED = 3,
}

// 顶部显示类型：1无，2奖金，3top标签，4hot标签，5游戏rtp，6在线人数，7收藏数

export interface GameItem {
  /**
   * 奖金
   */
  bonus: string;
  /**
   * 收藏数
   */
  favorite_count: number;
  /**
   * 游戏图片
   */
  game_img: string;
  game_img_json?: Record<string, string>;
  /**
   * 游戏ID
   */
  id: number;
  /**
   * 游戏名称
   */
  name: string;
  name_json?: Record<string, string>;
  /**
   * 支持的币种列表
   */
  currency_type: string[];
  /**
   * 在线人数
   */
  online_count: number;
  /**
   * 供应商ID
   */
  provider_id: number;
  /**
   * 供应商名称
   */
  provider_name: string;
  /**
   * RTP
   */
  rtp: string;
  /**
   * 状态：1 正常，2 维护，3 关闭
   */
  status: GameStatus;
  /**
   * 顶部显示类型：1无，2奖金，3top标签，4hot标签，5游戏rtp，6在线人数，7收藏数
   */
  top_show_type: number;
  /**
   * 游戏类型
   */
  game_type: number;
}

export interface SubjectItem {
  /**
   * 游戏数量
   */
  game_num: number;
  /**
   * 图片
   */
  img: string;
  img_json?: Record<string, string>;
  /**
   * 厂商id(0代表自定义游戏机)
   */
  provider_id: number;
  /**
   * 厂商名称
   */
  provider_name: string;
  /**
   * 厂商名称
   */
  provider_name_en?: string;
  /**
   * 主题名称
   */
  name?: string;
  /**
   * 主题名称
   */
  name_en?: string;
  /**
   * 主题uuid
   */
  subject_uuid: string;
}

export const getHomeInfo = (params: HomeReq) => get<HomeRes>('/hall/casino/v1/home', { params });

export const useHomeInfo = createApiQuery(getHomeInfo, (params: HomeReq) => ['casino-homeInfo', params]);